import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\GetItemsDossierForManageStockController::__invoke
* @see app/Http/Controllers/Dossier/GetItemsDossierForManageStockController.php
* @route '/api/dossier/{dossier}/items-for-manage-stock'
*/
const GetItemsDossierForManageStockController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemsDossierForManageStockController.url(args, options),
    method: 'get',
})

GetItemsDossierForManageStockController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/items-for-manage-stock',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\GetItemsDossierForManageStockController::__invoke
* @see app/Http/Controllers/Dossier/GetItemsDossierForManageStockController.php
* @route '/api/dossier/{dossier}/items-for-manage-stock'
*/
GetItemsDossierForManageStockController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return GetItemsDossierForManageStockController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\GetItemsDossierForManageStockController::__invoke
* @see app/Http/Controllers/Dossier/GetItemsDossierForManageStockController.php
* @route '/api/dossier/{dossier}/items-for-manage-stock'
*/
GetItemsDossierForManageStockController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemsDossierForManageStockController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\GetItemsDossierForManageStockController::__invoke
* @see app/Http/Controllers/Dossier/GetItemsDossierForManageStockController.php
* @route '/api/dossier/{dossier}/items-for-manage-stock'
*/
GetItemsDossierForManageStockController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemsDossierForManageStockController.url(args, options),
    method: 'head',
})

export default GetItemsDossierForManageStockController